import React, { PropsWithChildren } from 'react';

import styles from './field-overlay.module.scss';

type OverlayProps = PropsWithChildren<{}>;
export default function FieldOverlay(props: OverlayProps) {
    const { children } = props;
    if (!children) return null;
    return <div className={styles.overlay}>{children}</div>;
}
